// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__HrFQy","fileBtn":"File_fileBtn__3DNHF","closeBtn":"File_closeBtn__2PNkh","fileSelected":"File_fileSelected__58Tib","disabled":"File_disabled__L5BOq"};